NtechApp.RecentChatsSelectList = function(nav) {
    var me = this;

    this._ajax = null;
    this._click = null;
    this._nav = null;

    this._loader = null;
    this._overlay = null;

    this._list = null;
    this._$itemsGrid = null;
    this._$itemsGridContent = null;
    this._$noMessagesItem = null;
    this._$seeAllItem = null;

    this._isLoaded = false;

    this._construct = function () {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();
        me._nav = nav;

        me._list = me._nav.getMessagesSelectList();
        me._$itemsGrid = me._list.getWrapper().find("[data-itemsGrid]");
        me._$itemsGridContent = me._list.getWrapper().find("[data-itemsGridContent]");
        me._$noMessagesItem = me._list.getWrapper().find("[data-noMessagesItem]");
        me._$seeAllItem = me._list.getWrapper().find("[data-seeAllItem]");

        me._loader = new NtechApp.Loader(
            25, 25, "absolute", me._$itemsGridContent
        );
        me._overlay = new NtechApp.Overlay(
            me._$itemsGridContent,
            {position: "absolute"}
        );

        me._bindEvents();
    }

    this._bindEvents = function () {
        $(me._nav).on(NtechApp.Nav.EVENT_SELECTLIST_NAV_ITEM_SELECT, function(e, itemName, item) {
            if(me._isLoaded)
                return;

            if(itemName == "messages")
                me._loadRecentChatsList(item);
        });

        me._click.listen(me._$itemsGridContent, "[data-chatModel]", function(e) {
            var $chatItem = $(e.target).closest("[data-chatModel]");
            $(me).trigger(NtechApp.RecentChatsSelectList.EVENT_ITEM_SELECT, [$chatItem.attr("data-chatModel")]);
        });

        $(window).on(NtechApp.WINDOW_EVENTS.EVENT_CHAT_MESSAGES_VIEWED, function(e, chatId) {
            var $chat = me._$itemsGridContent.find("[data-chatModel='" + chatId + "']");
            $chat.find("[data-chatNotViewedMessagesCounter]").css("display", "none");
        });

        $(window).on(NtechApp.WINDOW_EVENTS.EVENT_MARK_ALL_READ, function() {
            me._$itemsGridContent.find("[data-chatNotViewedMessagesCounter]").css("display", "none");
        });

        var $wrapper = me._list.getWrapper();
        me._click.listen($wrapper, "[data-markAllReadTrigger]", function(e) {
            e.preventDefault();
            e.stopPropagation();

            var $item = $(e.target).closest("[data-markAllReadTrigger]");
            NtechApp.chatServices.saveMarkAllRead($item);

            return false;
        });
    }

    this._unbindEvents = function () {
        ;
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.RecentChatsSelectList.EVENT_ITEM_SELECT = "NtechApp.RecentChatsSelectList.EventItemSelect";

NtechApp.proto(NtechApp.RecentChatsSelectList, {
    _loaderOn: function() {
        this._loader.on();
        this._overlay.on();
    },

    _loaderOff: function() {
        this._loader.off();
        this._overlay.off();
    },

    _getRecentChatsListRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_load_recent_chats_list';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_load_recent_chats_list';
    },

    _loadRecentChatsList: function(item) {
        this._loaderOn();
        var me = this;

        me._ajax.get({
            url: Routing.generate(me._getRecentChatsListRoute()),
            onSuccess: function(data) {
                me._$itemsGridContent.html($.parseHTML(data.html));
                me._updateChatsGrid(data.noChats, data.hasMoreChats);

                me._isLoaded = true;
                me._bindAjaxPollingUpdates();
            },
            onComplete: function() {
                me._loaderOff();
            }
        });
    },

    _updateChatsGrid: function(noChats, hasMoreChats) {
        var me = this;
        NtechApp.dateTools.convertDates(me._$itemsGridContent);

        if(noChats) {
            me._$noMessagesItem.removeClass("hidden");
            me._$itemsGrid.addClass("hiddenGrid");
        }
        else {
            me._$itemsGrid.removeClass("hiddenGrid");
            me._$noMessagesItem.addClass("hidden");
        }

        if(hasMoreChats)
            me._$seeAllItem.removeClass("hidden");
        else
            me._$seeAllItem.addClass("hidden");
    },

    _bindAjaxPollingUpdates: function() {
        var me = this;

        NtechApp.ajaxPolling.addPullRequestParamsResolver(function() {
            var $chats = me._$itemsGridContent.find("[data-chatModel]");
            var $chatWithLatestDate = NtechApp.dateTools.getItemWithLatestDate(
                $chats, "data-updatedAt"
            );

            var params = {};
            if($chatWithLatestDate != null) {
                params["pullSelectListChats"] = $chatWithLatestDate.attr("data-updatedAt");
            }
            else {
                params["pullAllSelectListChats"] = true;
            }

            return params;
        });

        $(NtechApp.ajaxPolling).on(NtechApp.AjaxPolling.EVENT_ON_DATA_PULL, function(e, data) {
            if(!data.wasSelectListChatsUpdated)
                return;

            me._$itemsGridContent.find("[data-chatModel]").remove();
            me._$itemsGridContent.append($.parseHTML(data.selectListChatsHtml));

            me._updateChatsGrid(data.noSelectListChats, data.hasMoreSelectListChats);
        });
    }
});